import React from 'react';
import { Row, Col, Card, Image } from 'react-bootstrap';
import PropTypes from 'prop-types';
import harryNguyen from 'assets/img/team-members/harry-nguyen.jpg';
import barryOSullivan from 'assets/img/team-members/barryosullivan.png';
import shanPan from 'assets/img/team-members/shan-pan.png';
import alexTo from 'assets/img/team-members/alex-to.jpg';
import joseph from 'assets/img/team-members/joseph.jpg';
import uyen from 'assets/img/team-members/uyen.jpg';

const leads = [
  {
    name: 'Dr. Harry Nguyen',
    img: harryNguyen,
    affiliation: 'University College Cork',
    country: 'Cork, Ireland'
  },
  {
    name: 'Prof. Barry O’Sullivan',
    img: barryOSullivan,
    affiliation: 'University College Cork',
    country: 'Cork, Ireland'
  },
  {
    name: 'Prof. Shan L Pan',
    img: shanPan,
    affiliation: 'University of New South Wales',
    country: 'Sydney, Australia'
  }
];

const members = [
  {
    name: 'Alex To',
    img: alexTo,
    affiliation: 'University of Sydney',
    country: 'Sydney, Australia'
  },
  {
    name: 'Joseph Chai',
    img: joseph,
    affiliation: 'University College Cork',
    country: 'Cork, Ireland'
  },
  {
    name: 'Uyen Dinh',
    img: uyen,
    affiliation: 'University College Cork',
    country: 'Cork, Ireland'
  }
];

const Profile = ({ profile }) => {
  return (
    <Col md={3} key={profile.name}>
      <Card>
        <Card.Body>
          <Row className="g-3 align-items-center">
            <Col md={6} lg={12} className="text-center">
              <Image
                src={profile.img}
                alt={profile.name}
                fluid
                className="rounded-3"
              />
            </Col>
            <Col md={6} lg={12}>
              <Row className="row-cols-1 g-0">
                <Col className="text-center">
                  <h6>{profile.name}</h6>
                  <h6>{profile.affiliation}</h6>
                  <p className="mb-0 fs-10">{profile.country}</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

Profile.propTypes = {
  profile: PropTypes.object.isRequired
};

const TeamMembers = () => {
  return (
    <>
      <Row className="mb-2">
        <h6>Project Leads</h6>
      </Row>
      <Row className="mb-3">
        {leads.map(member => (
          <Profile profile={member} key={member.name} />
        ))}
      </Row>
      <Row className="mb-2">
        <h6>Team Members</h6>
      </Row>
      <Row>
        {members.map(member => (
          <Profile profile={member} key={member.name} />
        ))}
      </Row>
    </>
  );
};

export default TeamMembers;
